module.exports = __webpack_public_path__ + "img/lg_ring_y_o_0_0@2x.2ac97a44.png";